import { Component, OnInit, ElementRef } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { WMAIApiService, Word } from '../core';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { Alert } from '../core/models';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal } from 'src/app/core/templates';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {

    myAlert: Alert = new Alert();
    results: Alert[] = [];
    prioritaList: Word[] = [];

    currentAlert: Alert = new Alert();
    resultsCount: number;
    loading = false;
    currentPage = 1;
    limit: number = 6;
    totalPages: Array<number> = [1];

    addItaliano: boolean = false;
    addInglese: boolean = false;
    addFrancese: boolean = false;
    addNewAlert: boolean = false;
    modItaliano: boolean = false;
    modInglese: boolean = false;
    modFrancese: boolean = false;
    modifyThisAlert: number = null;

    language = this.translateService.getDefaultLang();

    constructor(
        private wgisservice: WgisService,
        private router: Router,
        private wmaiservice: WMAIApiService,
        private modalService: SuiModalService,
        private translateService: TranslateService
    ) {
        this.wgisservice.setMapInvisible();
    }
    ngOnInit() {
        this.getPrioritaList();
        //this.setInputLanguage();
        this.getAlertsList();
    }
    /**
     * ottieni la lista delle priorita 
     */
    getPrioritaList() {
        this.wmaiservice.getWordsByKeywordLocale(this.translateService.getDefaultLang(), 'priorita').subscribe(data => {
            if (data != null) {
                this.prioritaList = data;
                // console.log(this.prioritaList);
            }
        });
    }
    /**
     * ottieni la lista degli alert
     */
    getAlertsList() {
        this.wmaiservice.getAllAlerts(this.currentPage).subscribe(data => {
            this.results = data['data'];
            let mio = [];
            if (data['data'] != null) {
                // console.log(data['data']);
                //this.results = this.groupById(mio);
            }

            if (data['metadata']['rowCount'] != null) {
                this.resultsCount = data['metadata']['rowCount'];
                let tmp = Math.ceil(this.resultsCount / this.limit);
                this.totalPages = this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
            }
        });
    }
    /** setta lo stile attraverso il parametro
     * @param  {} priority
     */
    setMyStyle(priority) {
        let style = {};
        switch (priority) {
            case 1297:
                style = { 'background': 'white' };
                break;
            case 1298:
                style = { 'background': 'orange' };
                break;
            case 1300:
                style = { 'background': 'red' };
                break;
        }
        return style;
    }

    /** ragguppa attraverso il parametro
     * @param  {} array
     */
    groupById(array) {
        let result: Alert[] = [];

        // console.log(array);
        var y;

        var i;
        for (y = 0; y < array.length; y++) {
            // console.log(y);
            let alert: Alert = new Alert();
            alert.id = array[y].id;
            alert.priorita = array[y].priorita;
            alert.datastart = array[y].datastart;
            alert.dataend = array[y].dataend;
            switch (array[y].locale) {
                case 'it':
                    alert.title_it = array[y].title;
                    alert.description_it = array[y].description;
                    break;
                case 'en':
                    alert.title_en = array[y].title;
                    alert.description_en = array[y].description;
                    break;
                case 'fr':
                    alert.title_fr = array[y].title;
                    alert.description_fr = array[y].description;
                    break;
            }
            for (i = y; i < array.length; i++) {
                // console.log(array[y].id + " - " + array[i].id);
                if (array[y].id == array[i].id && array[y].locale != array[i].locale) {
                    console.log(array[y].locale + ' - ' + array[i].locale)
                    switch (array[i].locale) {
                        case 'it':
                            // console.log('entrato ' + i);
                            alert.title_it = array[i].title;
                            alert.description_it = array[i].description;
                            break;
                        case 'en':
                            // console.log('entrato ' + i);
                            alert.title_en = array[i].title;
                            alert.description_en = array[i].description;
                            break;
                        case 'fr':
                            // console.log('entrato ' + i);
                            alert.title_fr = array[i].title;
                            alert.description_fr = array[i].description;
                            break;
                    }
                    array.splice(i, 1);
                    i = i - 1;
                }
            }
            result.push(alert);
        }
        // console.log(result);
        return result;
    }
    /**
     *si setta l'immagine di input
     */
    setInputLanguage() {
        switch (this.language) {
            case 'it':
                this.addItaliano = true;
                break;
            case 'en':
                this.addInglese = true;
                break;
            case 'fr':
                this.addFrancese = true;
                break;
        }
    }
    /** si chiedono i campi di lingua 
     * @param  {Alert} alert
     */
    viewLanguageFields(alert: Alert) {
        if (alert.description_it.length > 0) {
            this.modItaliano = true;
        }
        if (alert.description_en.length > 0) {
            this.modInglese = true;
        }
        if (alert.description_fr.length > 0) {
            this.modFrancese = true;
        }
    }

    togleItaliano() {
        this.addItaliano = !this.addItaliano;
    }
    togleInglese() {
        this.addInglese = !this.addInglese;
    }
    togleFrancese() {
        this.addFrancese = !this.addFrancese;
    }

    resetTogleModify() {
        this.modItaliano = false;
        this.modInglese = false;
        this.modFrancese = false;
    }

    togleModItaliano() {
        this.modItaliano = !this.modItaliano;
    }
    togleModInglese() {
        this.modInglese = !this.modInglese;
    }
    togleModFrancese() {
        this.modFrancese = !this.modFrancese;
    }

    addAlert() {
        this.addNewAlert = !this.addNewAlert;
    }

    modifyAlert(alert: Alert) {
        this.resetTogleModify();
        this.modifyThisAlert = alert.id;
        this.currentAlert = alert;
        this.viewLanguageFields(alert);
    }

    cancel(form: NgForm) {
        this.myAlert = new Alert();
        this.addNewAlert = !this.addNewAlert;
    }

    cancelModify() {
        this.currentAlert = new Alert();
        this.modifyThisAlert = null;
    }
    /** rimuovi l'alert attraverso il paramentro
     * @param  {} id
     */
    removeAlert(id) {
        let title: string = this.translateService.instant('modal.notifications.delete.title');
        let content: string = this.translateService.instant('modal.notifications.delete.content');
        this.modalService
            .open(new ConfirmModal(title, content, ModalSize.Normal))
            .onApprove(() => {
                this.wmaiservice.deleteAlert(id).subscribe(data => {
                    this.results = this.results.filter(element => {
                        return element.id != id;
                    })
                })
            })
            .onDeny(() => "");
    }
    /**
     *si controlla la truduzione dopo aver schiaccito il submit che scatena un alert
     */
    submit() {
        this.checkLanguage();
        this.wmaiservice.insertAlert(this.myAlert).subscribe(data => {
            this.myAlert.id = data.id;
            this.results.unshift(this.myAlert);
            this.myAlert = new Alert();
            this.addNewAlert = !this.addNewAlert;
        });
    }
    /**
     * si controlla lingua e si esegue la traduzione fr e en
     * */
    checkLanguage() {
        if (this.myAlert.title_fr.length == 0 || this.myAlert.title_fr.length == null) {
            this.myAlert.title_fr = this.myAlert.title_it;
            this.myAlert.description_fr = this.myAlert.description_it;
        }
        if (this.myAlert.description_fr.length == 0 || this.myAlert.description_fr.length == null) {
            this.myAlert.description_fr = this.myAlert.description_it;
            this.myAlert.title_fr = this.myAlert.title_it;
        }
        if (this.myAlert.title_en.length == 0 || this.myAlert.title_en.length == null) {
            this.myAlert.title_en = this.myAlert.title_it;
            this.myAlert.description_en = this.myAlert.description_it;
        }
        if (this.myAlert.description_en.length == 0 || this.myAlert.description_en.length == null) {
            this.myAlert.description_en = this.myAlert.description_it;
            this.myAlert.title_en = this.myAlert.title_it;
        }
    }

    dateChangeStart() {
        if (this.myAlert.datastart > this.myAlert.dataend) {
            this.myAlert.dataend = this.myAlert.datastart;
        }
    }

    dateChangeEnd() {
        if (this.myAlert.dataend < this.myAlert.datastart) {
            this.myAlert.datastart = this.myAlert.dataend;
        }
    }

    dateChangeModifyStart() {
        if (this.currentAlert.datastart > this.currentAlert.dataend) {
            this.currentAlert.dataend = this.currentAlert.datastart;
        }
    }

    dateChangeModifyEnd() {
        if (this.currentAlert.dataend < this.currentAlert.datastart) {
            this.currentAlert.datastart = this.currentAlert.dataend;
        }
    }

    submitModify(alert: Alert) {
        this.wmaiservice.updateAlert(this.currentAlert).subscribe(data => {
            // console.log('inviato');
            alert = this.currentAlert;
            this.currentAlert = new Alert();
            this.modifyThisAlert = null;
        });
    }

    setPageTo(pagenumber) {
        this.currentPage = pagenumber;
        this.getAlertsList();
    }
}
